module.exports = {
    api: 'https://cnodejs.org/api/v1/',
    timeout: 30000
}
